import firebase from 'firebase/app'
require('firebase/auth')
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyB6sFP-kKzFiiXFYAP7KcVxi5UfYbX3b7k",
    authDomain: "alfa-e48cd.firebaseapp.com",
    projectId: "alfa-e48cd",
    storageBucket: "alfa-e48cd.appspot.com",
    messagingSenderId: "565715755066",
    appId: "1:565715755066:web:199144b96d72c1d2fe5503",
    measurementId: "G-BCR9R8D62K"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase